module.exports = __webpack_public_path__ + "img/9788971968543.bbed306c.jpg";